import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { svgSprite } from '../../../../../../../../hybrid/wrappers';
import css from './NewsSearch.module.scss';
import T from '../../../../../../../../common/components/T';
import FormInput from '../../../../../../../../widgets/form/components/form-input/FormInput/FormInput';
import { getData } from '../../../../../../../../common/utils/router';
import UserContext from '../../../../../../../../common/utils/getContext';
import classNames from 'classnames';
import Link from 'next/link';
import { checkBrowser } from '../../../../../../../../common/utils/utils';
import NewsImage from '../../../../../../../../widgets/newsImage/NewsImage';

const NewsSearch = () => {
    const { userToken, lang } = useContext(UserContext);
    const [modal, setModal] = useState(false);
    const [news, setNews] = useState(null);
    const [searchText, setSearchText] = useState('');

    const interval = useRef(null);

    const [searchSettings, setSearchSettings] = useState({
        page: 1
    });

    const search = useCallback(
        async (text) => {
            setSearchText(text);
            getData(`/api/v1/news?filter[q]=${text}&page[number]=1&page[size]=3`, userToken, lang).then((res) => {
                setNews(res);
            });
        },
        [userToken, lang, searchSettings]
    );

    const onSearch = useCallback(
        (text) => {
            clearTimeout(interval.current);
            interval.current = setTimeout(async () => {
                await search(text);
            }, 500);
        },
        [search]
    );

    const inputConfig = {
        title: { body: <T textName='search' defaultStr='Поиск' /> },
        search: {
            type: 'onInput',
            icon: 'search-gt'
        },
        compStyle: {
            inner: css.formInputInner
        },
        handlers: {
            onChange: onSearch
        }
    };

    const paginationHandler = useCallback(
        (arrow) => {
            setSearchSettings((state) => ({
                ...state,
                page: arrow === 'left' ? state.page - 1 : state.page + 1
            }));
            getData(
                `/api/v1/news?filter[q]=${searchText}&page[number]=${
                    arrow === 'left' ? searchSettings.page - 1 : searchSettings.page + 1
                }&page[size]=3`,
                userToken,
                lang
            ).then((res) => {
                setNews(res);
            });
        },
        [userToken, lang, searchSettings, searchText]
    );

    useEffect(() => {
        if (!modal) {
            setNews(null);
            setSearchSettings({ page: 1 });
            setSearchText('');
            // document.body.style.height = 'auto';
            // document.body.style.overflow = 'initial';
        } else {
            // document.body.style.height = '100%';
            // document.body.style.overflow = 'hidden';
        }
    }, [modal]);

    return (
        <div className={css.wrapper}>
            <div onClick={() => setModal((s) => !s)} className={css.searchBtn}>
                {svgSprite('search-gt')}
            </div>
            {modal ? (
                <div style={{ height: checkBrowser(100) + 'vh' }} onClick={() => setModal(false)} className={css.searchModalBg}>
                    <div onClick={(e) => e.stopPropagation()} className={css.searchModal}>
                        <div className={css.searchModalContent}>
                            <div className={css.head}>
                                <p className={css.title}>
                                    <T textName='what_are_you_looking_for' defaultStr='Что вы ищите' />
                                </p>
                                <div onClick={() => setModal(false)} className={css.closeBtn}>
                                    {svgSprite('cross-gt')}
                                </div>
                            </div>
                            <FormInput {...inputConfig} />
                            {news ? (
                                <div className={css.news}>
                                    <div className={css.newsHead}>
                                        <div className={css.newsFounded}>
                                            <p className={css.newsFoundedTitle}>
                                                <T textName='founded_news' defaultStr='Найдено новостей' />
                                            </p>
                                            <div className={css.newsFoundedNumber}>{news?.meta?.total || '0'}</div>
                                        </div>
                                        {news?.meta?.total > 0 ? (
                                            <div className={css.paginationArrows}>
                                                <div
                                                    onClick={() => paginationHandler('left')}
                                                    className={classNames(
                                                        css.paginationArrow,
                                                        +news?.meta?.current_page <= 1 && css.paginationArrowDisabled
                                                    )}
                                                >
                                                    {svgSprite('arrow-left-gt-store')}
                                                </div>
                                                <div
                                                    onClick={() => paginationHandler('right')}
                                                    className={classNames(
                                                        css.paginationArrow,
                                                        +news?.meta?.last_page === searchSettings?.page &&
                                                            css.paginationArrowDisabled
                                                    )}
                                                >
                                                    {svgSprite('arrow-right-gt-store')}
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>
                                    {news?.data?.length ? (
                                        <div className={css.newsList}>
                                            {news?.data?.map((item) => (
                                                <Link href={`/news/${item.seo_url}`} className={css.newsItem} key={item.id}>
                                                    <div className={css.newsImageWrapper}>
                                                        {/* {item?.image?.link ? (
                                                            <Img
                                                                className={css.newsImage}
                                                                src={item?.image?.link}
                                                                alt={'News Image'}
                                                            />
                                                        ) : (
                                                            svgSprite('plug-load-image-gt', { className: css.newsPlug })
                                                        )} */}
                                                        <NewsImage customStyles={css} item={item} />
                                                    </div>
                                                    <div className={css.newsItemInfo}>
                                                        <p className={css.newsItemTitle}>{item.title}</p>
                                                        <div className={css.newsItemDateWrapper}>
                                                            <div className={css.newsItemDate}>
                                                                {svgSprite('calendar-news', { className: css.newsItemDateIcon })}
                                                                <p className={css.greyLabel}>{item.created_at}</p>
                                                            </div>
                                                            <div className={css.line}></div>
                                                            <div className={css.newsCategories}>
                                                                {item?.categories?.map((category) => (
                                                                    <div className={css.newsCategory} key={category.id}>
                                                                        <div className={css.circle}></div>
                                                                        <p className={css.greyLabel}>{category.title}</p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Link>
                                            ))}
                                        </div>
                                    ) : null}
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default NewsSearch;
